export default __webpack_public_path__ + "static/media/closer-watt.9f11160a.mp3";